"use client";
import { useFlows } from "@/components/flows/useFlows";

export function SupportButton() {
  const f = useFlows();
  return <button className="btn foot-support" onClick={() => f.openSupport()}><span className="fs-dot" /> Live support · we&apos;re here</button>;
}
export function ShippingLink() {
  const f = useFlows();
  return <a href="#" onClick={(e) => { e.preventDefault(); f.openShipping(); }}>Shipping</a>;
}
